import { render } from "./App.vue?vue&type=template&id=094e86ab&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=094e86ab&lang=scss"

import exportComponent from "/codebuild/output/src277174800/src/yosrow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__